module.exports = __webpack_public_path__ + "img/KinokoTable50.469f9f2a.jpg";